import Media from "@PegasusCore/pegasus-one-media/src/script.js";

class CustomMedia extends Media {
    videoModalOpen = false;
    lottie = null;

    init() {
        super.init();

        const modalVideo = this.$el.querySelector(".modal-video");
        this.lottie = this.$el.querySelector("lottie-player");

        if (!modalVideo && !this.lottie) {
            return;
        }

        this.video = modalVideo;

        if (this.video) {
            // Assign the embed video type if needed
            if (this.video.classList.contains("video-embed")) {
                this.videoType = "embed";
            }
        }
    }

    pauseVideo() {
        // Standard HTML5 videos can simply use the play() and pause() methods.
        if (this.videoType === "upload") {
            this.video.pause();
            this.$refs.videoPlaceholder.classList.remove("hidden");
            console.log(this.video);
            return;
        }

        // Embed videos need to update the autoplay parameter in the URL.
        if (this.videoType === "embed") {
            const currentSrc = this.video.src;

            const currentSrcArray = currentSrc.split("&");

            let newSrc = "";

            currentSrcArray.forEach((part) => {
                if (part.includes("autoplay=")) {
                    part = "autoplay=0";
                }
                newSrc += part + "&";
            });

            this.video.src = newSrc;

            console.log(this.video.src);
        }

        this.$refs.videoPlaceholder.classList.remove("hidden");
    }

    onIntersect() {
        if (this.lottie) {
            this.playLottie();
        }
    }

    playLottie() {
        setTimeout(() => {
            this.lottie.play();
        }, 200);
    }
}

document.addEventListener("alpine:init", () => {
    Alpine.data("PegasusMediaBlock", () => new CustomMedia());
});
